import { Button, Card, Text } from "@mantine/core";
import { Truck } from "lucide-react";
import { useTranslation } from "react-i18next";

interface OrderTrackingActionCardProps {
  href: string;
}

export function OrderTrackingActionCard({
  href,
}: OrderTrackingActionCardProps) {
  const { t } = useTranslation();

  return (
    <Card p="md" withBorder data-testid="welcome-order-tracking-card">
      <Text fw={600} size="md" mb="xs">
        {t("welcome.orderTracking")}
      </Text>
      <Text size="sm" c="dimmed" mb="sm">
        {t("welcome.orderTrackingDesc")}
      </Text>
      <Button
        component="a"
        href={href}
        leftSection={<Truck size={16} aria-hidden="true" />}
        variant="light"
        size="sm"
        data-testid="welcome-order-tracking-link"
      >
        {t("welcome.orderTrackingCta")}
      </Button>
    </Card>
  );
}
